import React, { useState } from 'react';
import { Tooltip, Typography } from 'antd';

const { Title } = Typography;

const TooltipTitle = ({ children, ellipsis, tooltipProps, ...props }) => {
  const [truncated, setTruncated] = useState(false);

  return (
    <Tooltip title={truncated ? children : undefined} {...tooltipProps}>
      <Title
        {...props}
        ellipsis={{
          ...ellipsis,
          onEllipsis: setTruncated,
        }}
      >
        <>{children}</>
      </Title>
    </Tooltip>
  );
};

export default TooltipTitle;
